export class Config {
  backendUrl: string;
  corilusPassportUrl: string;
  matomoBaseUrl: string;
  matomoSiteId: number;

  constructor() {
    this.backendUrl = "";
    this.corilusPassportUrl = "";
    this.matomoBaseUrl = "";
    this.matomoSiteId = 1;
  }
}

export const visitConfig = new Config();
